'use strict';

(function () {
	angular.module('app').filter('nwCaption', function () {
		return function (input) {
			return input && (input.caption || input.displayName || input.name) || '';
		};
	});
})();